module.exports = __webpack_public_path__ + "img/craf.6a46e5c6.png";